import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "d-flex justify-content-center my-3 mx-3" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-spinner fa-spin fa-3x" }, null, -1);
const _hoisted_3 = [
    _hoisted_2
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3));
}
